module.exports = __webpack_public_path__ + "1d5273958569b44238f70121af99bcba.png";